<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col sm="6" lg="4">
          <div class="form-group">
            <label
              for="notificationEnable"
              class="form-control-label">{{$t('views.excmtasktype.form.notificationEnable')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="notificationEnable" button-variant="outline-primary" v-model="item.notificationEnable" name="notificationEnable">
                <b-form-radio :value="0" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="1" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
        <b-col v-if="item.notificationEnable" sm="6" lg="4">
          <div class="form-group">
            <label
              for="notification"
              class="form-control-label">{{$t('views.excmtasktype.form.notification')}}:</label>
            <input
              id="excmtasktype_duration"
              v-model="item.notification"
              class="form-control"
              type="number"
              placeholder="">
          </div>
        </b-col>
        <b-col v-if="item.notificationEnable" sm="12" lg="4">
          <div class="form-group">
            <label
              for="excmtasktype_notificationTitle"
              class="form-control-label">{{$t('views.excmtasktype.form.notificationTitle')}}:</label>
            <input
              id="excmtasktype_notificationTitle"
              v-model="item.notificationTitle"
              class="form-control"
              placeholder="">
          </div>
        </b-col>
        <b-col v-if="item.notificationEnable" sm="12" lg="12">
          <div class="form-group">
            <label
              for="excmnote_description"
              class="form-control-label">{{$t('views.excmtasktype.form.notificationContent')}}</label>
            <textarea
              id="excmnote_description"
              v-model="item.notificationContent"
              class="form-control"
              type="text"
              placeholder=""></textarea>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" lg="4">
          <div class="form-group">
            <label
              for="alarmEnable"
              class="form-control-label">{{$t('views.excmtasktype.form.alarmEnable')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="alarmEnable" button-variant="outline-primary" v-model="item.alarmEnable" name="alarmEnable">
                <b-form-radio :value="0" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="1" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
        <b-col v-if="item.alarmEnable" sm="6" lg="4">
          <div class="form-group">
            <label
              for="alarm"
              class="form-control-label">{{$t('views.excmtasktype.form.alarm')}}:</label>
            <input
              id="excmtasktype_duration"
              v-model="item.alarm"
              class="form-control"
              type="number"
              placeholder="">
          </div>
        </b-col>
        <b-col v-if="item.alarmEnable" sm="12" lg="4">
          <div class="form-group">
            <label
              for="excmtasktype_alarmTitle"
              class="form-control-label">{{$t('views.excmtasktype.form.alarmTitle')}}:</label>
            <input
              id="excmtasktype_alarmTitle"
              v-model="item.alarmTitle"
              class="form-control"
              placeholder="">
          </div>
        </b-col>
        <b-col v-if="item.alarmEnable" sm="12" lg="12">
          <div class="form-group">
            <label
              for="excmnote_description"
              class="form-control-label">{{$t('views.excmtasktype.form.alarmContent')}}</label>
            <textarea
              id="excmnote_description"
              v-model="item.alarmContent"
              class="form-control"
              type="text"
              placeholder=""></textarea>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" lg="4">
          <div class="form-group">
            <label
              for="alarmEnable"
              class="form-control-label">{{$t('views.excmtasktype.form.alarmNotFinishedEnable')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="alarmNotFinishedEnable" button-variant="outline-primary" v-model="item.alarmNotFinishedEnable" name="alarmEnable">
                <b-form-radio :value="0" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="1" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
        <b-col v-if="item.alarmNotFinishedEnable" sm="6" lg="4">
          <p class="mt-4">{{$t('views.excmtasktype.form.duration')}}: {{item.duration}}
            <span v-if="item.durationUnit === 1">{{$t('global.timeMeasures.minutes')}}</span>
            <span v-else-if="item.durationUnit === 2">{{$t('global.timeMeasures.hours')}}</span>
            <span v-else-if="item.durationUnit === 3">{{$t('global.timeMeasures.days')}}</span>
            <span v-else-if="item.durationUnit === 4">{{$t('global.timeMeasures.workDays')}}</span>
            <span v-else-if="item.durationUnit === 5">{{$t('global.timeMeasures.workHours')}}</span>
          </p>
        </b-col>
        <b-col v-if="item.alarmNotFinishedEnable" sm="12" lg="4">
          <div class="form-group">
            <label
              for="excmtasktype_alarmNotFinishedTitle"
              class="form-control-label">{{$t('views.excmtasktype.form.alarmNotFinishedTitle')}}:</label>
            <input
              id="excmtasktype_alarmNotFinishedTitle"
              v-model="item.alarmNotFinishedTitle"
              class="form-control"
              placeholder="">
          </div>
        </b-col>
        <b-col v-if="item.alarmNotFinishedEnable" sm="12" lg="12">
          <div class="form-group">
            <label
              for="excmnote_description"
              class="form-control-label">{{$t('views.excmtasktype.form.alarmNotFinishedContent')}}</label>
            <textarea
              id="excmnote_description"
              v-model="item.alarmNotFinishedContent"
              class="form-control"
              type="text"
              placeholder=""></textarea>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="item.alarmEnable || item.notificationEnable || item.alarmNotFinishedEnable">
        <b-col sm="12" lg="12">
          <div class="form-group">
            <content-field-legend></content-field-legend>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>

import ContentFieldLegend from '@/components/Dashboard/Views/excmnotificationmessage/components/contentFieldLegend'
export default {
  name: 'taskNotifications',
  components: {
    ContentFieldLegend
  },
  props: {
    values: Object
  },

  computed: {
    item () {
      return this.values
    }
  },

  data () {
    return {
    }
  },

  watch: {
    'items' () {
      if (!(this.initialRoleWithPermissions.length > 0)) {
        this.getPermissionsArray(this.items)
      }
    },
    'roleWithPermissions' () {
      this.$emit('roleWithPermissions', this.roleWithPermissions)
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
